import React from 'react';
import { useMediaQuery } from 'react-responsive';
import PropTypes from 'prop-types';
import ProductPrice from '../../../helpers/ProductPrice';

import styles from './style.module.scss';
import BundleProductFeatures from '../../bundle-common/BundleProductFeatures';
import BundleGallery from '../../bundle-common/BundleGallery';

const BundleSections = (props) => {
  const {
    sections,
    getSectionProductsById,
    setActiveSection,
    cartItems,
    currencyCode,
  } = props;
  const isBigScreen = useMediaQuery({ query: '(min-width: 1024px)' });

  const openSection = (categories, sectionId) => {
    const productCount = isBigScreen ? 20 : 10;
    // Get first page of products
    getSectionProductsById({
      sectionId,
      categories,
      pageSize: productCount,
    });
    setActiveSection(sectionId);
  };

  const getProductData = (section) => cartItems.find((cartItem) => cartItem.option_id === section.record_id);

  const sectionProduct = (section) => {
    const sectionProductData = getProductData(section);

    if (!sectionProductData) {
      return <></>;
    }

    const imageSize = 160;

    return (
      <>
        {sectionProductData.productThumb && (
          <img
            src={`${sectionProductData.productThumb}?width=${imageSize}&height=${imageSize}&fit=bounds`}
            alt=""
          />
        )}
        <span>
          <p>{sectionProductData.name}</p>
          {(sectionProductData.optionName && sectionProductData.optionValue) && (
            <p>
              <strong>{`${sectionProductData.optionName}:`}</strong>
              <span>{sectionProductData.optionValue}</span>
            </p>
          )}

          { (sectionProductData.price === undefined) && (
            <span><strong>Click to choose your option</strong></span>
          )}

          { (sectionProductData.price !== undefined) && (
            <ProductPrice
              value={sectionProductData.minimalPrice}
              oldPrice={sectionProductData.oldPrice}
              currency={currencyCode}
              priceStyle={styles.sectionsProductPrice}
            />
          )}
        </span>
      </>
    );
  };

  return (
    <>
      {isBigScreen && (<BundleGallery products={cartItems} />)}
      <div className={styles.sectionsListWrapper}>
        <h4>Your Bundle</h4>
        <ul className={styles.sectionsList}>
          {sections.map((section) => (
            <li key={section.record_id} className={section.ready ? `${styles.section} ${styles.sectionReady}` : styles.section}>
              <button
                type="button"
                className={styles.sectionButton}
                aria-label={`Open ${section.section_name}`}
                onClick={() => { openSection(section.categories, section.record_id); }}
              >
                {(!section.ready) && (
                  <span>
                    <span className={styles.sectionButtonIcon}>
                      <svg viewBox="0 0 15 15">
                        <use xlinkHref="#icon-plus" />
                      </svg>
                    </span>
                    <span className={styles.sectionButtonLabel}>{section.section_name}</span>
                  </span>
                )}
                {section.ready && (sectionProduct(section))}
              </button>
              {section.ready && (<BundleProductFeatures product={getProductData(section)} />)}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

BundleSections.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.shape(
    {
      section_name: PropTypes.string,
      record_id: PropTypes.number,
      placeholder_image: PropTypes.string,
      products: PropTypes.arrayOf(PropTypes.shape({})),
      categories: PropTypes.arrayOf(PropTypes.number),
    },
  )),
  getSectionProductsById: PropTypes.func,
  setActiveSection: PropTypes.func,
  cartItems: PropTypes.arrayOf({}),
  currencyCode: PropTypes.string,
};

BundleSections.defaultProps = {
  sections: [],
  getSectionProductsById: () => {},
  setActiveSection: () => {},
  cartItems: [],
  currencyCode: 'GBP',
};

export default BundleSections;
